import React, { useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Dialog,
  Fab,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
  Toolbar,
  Typography,
  debounce,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Add, Close, Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { LoadingBox } from "../../../../../components/utils";
import AppFeedTable from "./components/AppFeedTable";
import { getFeed, getFeeds } from "../../../../services/mobileApi";
import { AppFeedDialog } from "./components/AppFeedDialog";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "primary",
    backgroundColor: "rgba(0, 0, 0, 0.25) !important",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppFeed() {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const companyCode = searchParams.get("company_code");
  const feedId = searchParams.get("feed_id");

  const tablePageIndex = Number(searchParams.get("page") ?? 1);
  const tablePageSize = Number(searchParams.get("page_size") ?? 50);

  const feedTableQuery = useQuery(
    ["app-feed", companyCode, tablePageIndex, tablePageSize, searchQuery],
    () =>
      getFeeds(companyCode.slice(0, 3), companyCode.slice(3, 7), searchQuery, {
        mostrarFuncao: true,
        mostrarCentroCusto: true,
        page: tablePageIndex,
        perPage: tablePageSize,
      }),
    {
      enabled: !!companyCode,
    },
  );

  const feedQuery = useQuery(["app-feed", feedId], () => getFeed(feedId), {
    enabled: !!feedId,
    onSuccess: () => setDialogOpen(true),
  });
  let feed = feedQuery.data?.data;
  feed = feed
    ? {
        id: feed.id,
        title: feed.title,
        banner: feed.banner,
        content: feed.content,
      }
    : null;

  const handleCloseDialog = () => {
    searchParams.delete("screen");
    setSearchParams(searchParams);
  };

  const handleCloseFeedDialog = () => {
    searchParams.delete("feed_id");
    setSearchParams(searchParams);

    setDialogOpen(false);
  };

  const handleCreateFeed = () => {
    setDialogOpen(true);
  };

  const searchDelayed = debounce(query => {
    setSearchQuery(query);
  }, 1000);

  const feedTable = feedTableQuery?.data?.data ?? [];
  const rows = feedTableQuery?.data?.meta?.total ?? 0;

  return (
    <Dialog
      fullScreen
      open
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      {dialogOpen && (
        <AppFeedDialog onClose={handleCloseFeedDialog} data={feed} />
      )}
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Notícias
          </Typography>
        </Toolbar>
      </AppBar>
      <Backdrop
        className={classes.backdrop}
        open={feedQuery?.isLoading ?? true}
      >
        <LoadingBox />
      </Backdrop>
      <Box sx={{ height: "calc(100% - 94px)", padding: "15px" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TextField
            style={{ width: "400px" }}
            label="Pesquisar"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={event => {
              searchDelayed(event.target.value);
            }}
          />
        </Box>
        <AppFeedTable data={feedTable} rows={rows} />
      </Box>
      <Fab
        color="primary"
        aria-label="add"
        className={classes.fab}
        onClick={handleCreateFeed}
      >
        <Add />
      </Fab>
    </Dialog>
  );
}
